import React from 'react'
import styled, { css } from 'styled-components'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

import Input from '../Input'
import Button from '../Button'

const Row = styled.div`
  display: flex;
  margin: 0 -12px 24px -12px;
`

const Col = styled.div`
  flex: 1;
  padding: 0 12px;

  ${props =>
    props.align === 'right' &&
    css`
      text-align: right;
    `}
`

const ADD_MUTATION = gql`
  mutation Signup(
    $firstname: String!
    $lastname: String!
    $email: String!
    $password: String!
  ) {
    signup(
      firstname: $firstname
      lastname: $lastname
      email: $email
      password: $password
    ) {
      firstname
      lastname
      email
    }
  }
`

const GET_USERS = gql`
  {
    users {
      id
      firstname
      lastname
      email
      isAdmin
    }
  }
`

class UserAdd extends React.Component {
  state = {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
  }

  onChange = (key, value) => {
    this.setState({
      [key]: value,
    })
  }

  onAddUpdate = (cache, { data }) => {
    // TODO: Fixes some weired data.users is not defined error. Probably needed because refetchQueries is not ready yet.
    setTimeout(() => {
      this.props.history.push('/admin/users')
    }, 300)
  }

  render() {
    const { onChange, onAddUpdate } = this
    const { firstname, lastname, email, password } = this.state

    return (
      <Mutation
        mutation={ADD_MUTATION}
        refetchQueries={[{ query: GET_USERS }]}
        update={onAddUpdate}
      >
        {(addUser, { data, error }) => (
          <form
            onSubmit={e => {
              e.preventDefault()
              addUser({ variables: { firstname, lastname, email, password } })
            }}
          >
            <Row>
              <Col>
                <Input
                  type="text"
                  placeholder="Vorname*"
                  fullwidth
                  required
                  value={this.state.firstname}
                  onChange={e => onChange('firstname', e.target.value)}
                />
              </Col>
              <Col>
                <Input
                  type="text"
                  placeholder="Nachname*"
                  fullwidth
                  required
                  value={this.state.lastname}
                  onChange={e => onChange('lastname', e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  type="email"
                  placeholder="E-Mail*"
                  fullwidth
                  required
                  value={this.state.email}
                  onChange={e => onChange('email', e.target.value)}
                />
              </Col>
              <Col>
                <Input
                  type="password"
                  placeholder="Passwort*"
                  fullwidth
                  required
                  value={this.state.password}
                  onChange={e => onChange('password', e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col align="right">
                <Button type="submit">Hinzufügen</Button>
              </Col>
            </Row>
          </form>
        )}
      </Mutation>
    )
  }
}

export default UserAdd
